<div class="fade modal modal-static pg-show-modal" id="modal-email-non-verified" tabindex="-1" role="dialog"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Postular a anuncio</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">
                <form role="form" action="#" method="post" id="search-email-link-form">
                    <div id="form-carousel-search-email-link" class="carousel slide" data-interval="false" data-keyboard="false">
                        <div class="carousel-inner transition-carousel-inner">
                            <div class="carousel-item active">
                                <div class="container-gray-200 text-center">
                                    <h5 class="font-size-16 heading-multi-styles">Postular a
                                        <br>
                                        <span
                                            class="font-size-18 font-weight-bold text-primary">{{jobTitle ? jobTitle : jobPosition}}</span>&nbsp;<ng-container *ngIf="jobGradeFrom">, <span class="font-size-18 font-weight-bold text-primary">{{jobGradeFrom}}<ng-container *ngIf="jobGradeFrom !== jobGradeTo"> a {{jobGradeTo}}</ng-container></span>
                                            </ng-container>
                                    </h5>
                                    <div class="alert alert-warning font-size-13 mgn-bottom-40 text-dark">
                                        <i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>&nbsp;Tu
                                        email&nbsp;
                                        <span class="font-weight-bold">no ha sido verificado</span>&nbsp;por lo
                                        tanto no
                                        puedes postular a este anuncio, verifica tu email
                                        para poder
                                        continuar.
                                    </div>
                                    <div class="text-center space-items-15" data-pg-collapsed>
                                        <button class="btn btn-outline-primary" data-dismiss="modal"
                                            type="button">Cancelar</button>
                                        <button class="btn btn-primary" type="submit" (click)="sendEmailLink($event)">Enviar
                                            link de verificación</button>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item successSlide">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center">
                                        <i
                                            class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico  pj-ico-modal-ok"></i>
                                        <p class="mgn-bottom-25 text-dark">Se ha enviado el link de
                                            verificación a
                                            tu dirección de correo registrado.</p>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center">
                                        <a class="btn btn-primary" href="#" data-dismiss="modal">Cerrar</a>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item errorSlide">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center">
                                        <i
                                            class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico  pj-ico-modal-error"></i>
                                        <h4 class="error-alert-heading text-primary">Lo sentimos, ha
                                            ocurrido un
                                            error</h4>
                                        <p class="mgn-bottom-25 text-dark">Presione el botón &ldquo;Volver a
                                            intentar&rdquo; para intentarlo otra vez de lo contrario
                                            presione
                                            &ldquo;Cancelar&rdquo; para salir de esta ventana.</p>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">
                                        <button class="btn btn-outline-primary" data-dismiss="modal"
                                            type="button">Cancelar</button>
                                        <button class="btn btn-primary" type="button" (click)="resetStepCarousel()">Volver a intentar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>